import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompanyContact } from '../shared/models/company-contract.model';
import { MyProfileService } from '../shared/services/my-profile.service';
import { PermissionService } from '../shared/services/permission.service';
import { SessionStorageService } from '../shared/services/session-storage.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-my-profile',
  styleUrls: ['./my-profile.component.scss'],
  templateUrl: './my-profile.component.html'
})
export class MyProfileComponent implements OnInit {

  companyContacts: Array<CompanyContact>;
  companyContext: string;
  companyName: string;
  isMultiCompanyUser: boolean;
  rawPermissionsSubscription: Subscription;

  constructor(private myProfileService: MyProfileService, private sessionStorage: SessionStorageService, private permissions: PermissionService, private titleService: Title) {
    this.sessionStorage.companyChange.subscribe( res => {
      this.companyContext = res;
      this.permissions.rawPermissions$.subscribe( rawPermissions => {
        if (rawPermissions.map( el => el.companyName ).length > 1) {
          this.myProfileService.getCompanyContactsByCompany(rawPermissions.filter( el => el.companyName === this.companyContext)[0].companyId.toString()).then( res => this.companyContacts = res);
        } else {
          this.myProfileService.getCompanyContactsByUser().then( res => this.companyContacts = res);
        }
      })
    })

    this.myProfileService.getSelf()
      .then( res => this.companyName = res.arvCompanyId.includes(',') ? res.arvCompanyId.split(',').filter( el => el === this.companyContext)[0] : this.companyContext);
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: My Profile');
  }

}
